import { DialogRef } from '@angular/cdk/dialog';

import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent } from "@angular/material/dialog";
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from "@ngneat/transloco";
import { ConceptSummaryErrorDetails } from '../../modules/admin/endpoints/endpoints.types';

@Component({
    selector: 'concept-summary-error-details-dialog',
    imports: [MatDialogContent, MatIcon, TranslocoModule, MatTooltipModule],
    templateUrl: './concept-summary-error-details-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './concept-summary-error-details-dialog.component.scss'
})
export class ConceptSummaryErrorDetailsDialogComponent {
    private dialogRef = inject(DialogRef<ConceptSummaryErrorDetailsDialogComponent>);
    public data: { error:  ConceptSummaryErrorDetails } = inject(MAT_DIALOG_DATA);
    public errorDetails = this.data.error;

    closeDialog() {
        this.dialogRef.close();
    }

    getRequestFields(): { label: string; value: any }[] {
        const request = this.errorDetails.net4Error?.request;
        if (!request) return [];
        
        return Object.entries(request)
            .map(([key, value]) => ({
                label: `errorDetails.request.${this.camelCase(key)}`,
                value: value
            }));
    }

    copyJsonToClipboard(object: any): void {        
        const jsonText = JSON.stringify(object, null, 2);

        navigator.clipboard.writeText(jsonText).then(() => {
        }).catch(err => {
            console.error('Failed to copy jsonText: ', err);
        });
    }

    private camelCase(str: string): string {
        if (str === str.toUpperCase()) {
            str = str.toLowerCase();
        }
        return str.charAt(0).toLowerCase() + str.slice(1);
    }
}
